<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M15.84 4.019a.256.256 0 01.192 0l9.462 3.816a.25.25 0 01-.006.468l-9.462 3.53a.256.256 0 01-.18 0l-9.364-3.53a.25.25 0 01-.007-.467l9.365-3.817zM28 9.333a.253.253 0 00-.345-.234l-10.817 4.128a.251.251 0 00-.162.234v14.287c0 .178.182.3.348.233l10.817-4.32A.251.251 0 0028 23.43V9.333zM4.346 9.101A.253.253 0 004 9.335V23.43c0 .102.062.194.157.233l10.648 4.317a.253.253 0 00.35-.232V13.46a.25.25 0 00-.161-.234L4.346 9.101z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsBoxFilled'
}
</script>
